import { FETCH_REQUEST, FETCH_SUCCESS, FETCH_ERROR } from '../../actions/blueprints/publicList';

const initialState = {
  isLoading: false,
  response: {
    models: [],
    pagination: {
      total: 0,
      page: 1,
      page_count: 0,
      has_next: false,
      has_prev: false
    }
  },
  error: null
};

function publicBlueprintsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        response: action.payload.response,
        error: null
      };

    case FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };

    default:
      return state;
  }
}

export const reducer = publicBlueprintsReducer; 